import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

import News_Item from '../components/News_Item';
import Container from '../components/Shared/Container';
import InnerContainer from '../components/Shared/InnerContainer';
import SectionHeader from '../components/Shared/SectionHeader';

const NewsPage = ({data}) => (
  <Container page>
    <InnerContainer>
      <SectionHeader>News and Updates</SectionHeader>
      {data.allContentfulNews.edges.map((edge, i) => {
        return (<News_Item key={i} news={edge.node} />)
      })}
    </InnerContainer>
  </Container>
)

export default NewsPage;

export const query = graphql`
  query NewsQuery {
    allContentfulNews (
      sort: { fields: [date], order: DESC }
    ) {
      edges {
        node {
          title
          date
          type
          description {
            description
          }
        }
      }
    }
  }
`;

// const Container = styled.div`
//   background-color: #eee;
//   flex-direction: column;
//   justify-content: center;
//   padding: 40px 10px;
//   min-height: 100vh;
//   font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
// `;
//
// const InnerContainer = styled.div`
//   max-width: 960px;
//   margin: auto;
//   padding: 20px;
//   color: #333;
// `;
//
// const SectionHeader = styled.h1`
//   text-align: center;
//   font-weight: 300;
// `;



// WEBPACK FOOTER //
// ./src/pages/news.js